import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconTranslateStyle0 = cosmosIconCss;

const CosmosIconTranslate$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTranslate extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '51618a1985640d290263fe65fcc3f03c892d26ce', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8e32828d40b6e7183e1ea39026d4d93be2152792', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd65ac2a52b0a4e505bb6a33ef403fe1a19f3f19c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.75 2.5h-1.5V4H4v1.5h1.146A8.683 8.683 0 0 0 6.86 8.114a9.36 9.36 0 0 1-2.139 1.19l.558 1.392A10.78 10.78 0 0 0 8.013 9.12c.882.646 1.879 1.145 2.959 1.577l.556-1.392c-.894-.358-1.693-.751-2.394-1.229A10.574 10.574 0 0 0 10.876 5.5H12V4H8.75V2.5Zm-.77 4.614c.45-.48.851-1.017 1.199-1.614h-2.37c.33.622.72 1.152 1.17 1.614Zm7.688 9.386L16.2 18h1.6l-2.123-5.934c-.395-1.106-1.959-1.106-2.354 0L11.2 18h1.6l.532-1.5h2.336Zm-.357-1-.81-2.27-.812 2.27h1.622ZM16 9V7a1 1 0 0 0-1-1h-2v1h2v2h1ZM6 13v2a1 1 0 0 0 1 1h2v-1H7v-2H6Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconTranslateStyle0; }
}, [1, "cosmos-icon-translate", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-translate"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-translate":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTranslate$1);
            }
            break;
    } });
}

const CosmosIconTranslate = CosmosIconTranslate$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTranslate, defineCustomElement };
